<template>
    <div>
        <v-layout align-center wrap>
            <v-flex xs11 sm6 lg6>
                <ApolloQuery :query="require('@/graphql/category/categories.gql')">
                    <template slot-scope="{ result: { data, loading } }">
                        <v-autocomplete
                            class="mt-3 ml-3 mr-3"
                            v-model="categoryFilter"
                            :items="data ? data.categories : []"
                            item-value="_id"
                            item-text="name"
                            :loading="loading"
                            attach
                            solo
                            chips
                            clearable
                            :label="$t('label.categories')"
                            multiple
                        ></v-autocomplete>
                    </template>
                </ApolloQuery>
            </v-flex>
            <v-flex xs1>
                <v-progress-circular
                    :size="28"
                    :width="3"
                    indeterminate
                    color="primary"
                    v-if="$apollo.queries.traps.loading"
                ></v-progress-circular>
            </v-flex>
            <v-flex xs1 sm1>
                <StatusHelper :outlined="false" />
            </v-flex>
            <v-flex xs11 sm4>
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-flex class="ml-3" align-self-center>
                        <strong
                            v-if="errorLocation"
                            v-t="`error.${errorLocation}`"
                            class="red--text small"
                        ></strong>
                    </v-flex>
                    <v-flex class="text-right">
                        <v-btn
                            @click="watchLocation"
                            type="button"
                            :loading="gpsLoading"
                            dark
                            rounded
                            :color="
                                positionAccuracy < 20
                                    ? 'green'
                                    : positionAccuracy > 50
                                    ? 'red'
                                    : 'orange'
                            "
                        >
                            <span v-if="positionAccuracy"
                                >{{ positionAccuracy }} {{ $t("m") }}</span
                            >
                            <v-icon :right="Boolean(positionAccuracy)">gps_fixed</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <GmapMap
            style="height: 100vh; width: 100%;"
            class="gmap"
            :zoom="7"
            ref="map"
            :center="{ lng: 8.182963, lat: 46.862549 }"
            @idle="idle"
            :options="{
                tilt: 0,
                disableDefaultUI: true,
                zoomControl: true,
                maxZoom: 20,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                mapTypeId: 'hybrid',
                gestureHandling: 'auto',
            }"
        >
            <GmapMarker
                :key="key"
                v-for="(t, key) in traps"
                :position="t.geoLocation"
                :clickable="true"
                :icon="getIcon(t)"
                @click="activeTrap = t"
            />
            <gmap-info-window
                v-if="activeTrap"
                :position="activeTrap.geoLocation"
                @closeclick="activeTrap = null"
            >
                <TrapPopup :trap="activeTrap" />
            </gmap-info-window>
            <GmapMarker
                ref="meMarker"
                :position="gpsPosition"
                v-if="gpsPosition"
                :icon="{
                    url: require('@/assets/geomarker.png'),
                    size: new google.maps.Size(55, 55),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 17),
                    scaledSize: new google.maps.Size(34, 34),
                }"
            />
        </GmapMap>
    </div>
</template>
<script>
import GeoLocation from "@/utils/GeoLocation"
import TrapPopup from "@/components/TrapPopup"
import StatusHelper from "@/components/StatusHelper"
import { gmapApi } from "vue2-google-maps"
require("@/assets/geomarker.png")
export default {
    components: {
        TrapPopup,
        StatusHelper,
    },
    apollo: {
        traps: {
            query: require("@/graphql/trap/traps.gql"),
            update({ traps }) {
                traps = (traps || []).filter(t => t.geoLocation && t.geoLocation.lat)
                this.panToBounds(traps)
                return traps
            },
            pollInterval: 20000,
            variables() {
                return {
                    categories: this.categoryFilter,
                }
            },
        },
    },
    data() {
        return {
            geoLocation: new GeoLocation(),
            gpsLoading: false,
            positionAccuracy: null,
            gpsPosition: null,
            firstLoad: true,
            errorLocation: false,
            activeTrap: null,
            categoryFilter: [],
        }
    },
    props: {
        positionField: { type: String, default: "geoLocation" },
        data: {
            type: Array,
            default() {
                return []
            },
        },
        parcels: {
            type: Array | null,
            default() {
                return null
            },
        },
        width: { type: String, default: "100%" },
        height: { type: String, default: "460px" },
    },

    beforeDestroy() {
        this.geoLocation.stopWatch()
        this.$apollo.queries.traps.stopPolling()
    },
    deactivated() {
        this.geoLocation.stopWatch()
        this.$apollo.queries.traps.stopPolling()
    },
    methods: {
        getIcon(trap) {
            if (!this.google) {
                return null
            }
            if (!trap.status) {
                return this.icon.noStatus
            }
            if (trap.status.right && trap.status.left) {
                return this.icon.armed
            } else if (!trap.status.right && !trap.status.left) {
                return this.icon.allTriggered
            } else if (!trap.status.right || !trap.status.left) {
                return this.icon.halfTriggered
            }
        },
        idle() {
            if (this.firstLoad) {
                this.panToBounds(this.traps || [])
                this.firstLoad = false
            }
        },
        panToBounds(traps) {
            if (this.$refs.map) {
                this.$refs.map.$mapPromise.then(map => {
                    const bounds = new this.google.maps.LatLngBounds()

                    for (let value of traps) {
                        bounds.extend({
                            lng: parseFloat(value.geoLocation.lng),
                            lat: parseFloat(value.geoLocation.lat),
                        })
                    }

                    if (!bounds.isEmpty()) {
                        map.setCenter(bounds.getCenter())
                        map.fitBounds(bounds)
                    }
                })
            }
        },

        watchLocation() {
            if (this.gpsPosition) {
                this.$refs.map.$mapPromise.then(map => {
                    map.setCenter(this.gpsPosition)
                    this.$emit("moved", map)
                })
                return
            }
            this.gpsLoading = true
            this.errorLocation = false
            this.geoLocation.watch(
                position => {
                    this.positionAccuracy = position.coords.accuracy.toFixed(2)
                    this.gpsLoading = false
                    const p = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }

                    if (!this.gpsPosition) {
                        this.$refs.map.$mapPromise.then(map => {
                            map.setCenter(p)
                            this.$emit("moved", map)
                        })
                    }
                    this.gpsPosition = p
                },
                e => {
                    this.errorLocation = e
                    this.gpsLoading = false
                    this.geoLocation.stopWatch()
                }
            )
        },
    },
    computed: {
        google: gmapApi,
        icon() {
            if (!this.google) {
                return {}
            }
            return {
                noStatus: {
                    url: require("../../assets/marker/no_status.svg"),
                    size: new this.google.maps.Size(30, 30),
                    origin: new this.google.maps.Point(0, 0),
                    anchor: new this.google.maps.Point(16, 16),
                    scaledSize: new this.google.maps.Size(30, 30),
                },
                armed: {
                    url: require("../../assets/marker/armed.svg"),
                    size: new this.google.maps.Size(30, 30),
                    origin: new this.google.maps.Point(0, 0),
                    anchor: new this.google.maps.Point(16, 16),
                    scaledSize: new this.google.maps.Size(30, 30),
                },
                allTriggered: {
                    url: require("../../assets/marker/all_triggered.svg"),
                    size: new this.google.maps.Size(30, 30),
                    origin: new this.google.maps.Point(0, 0),
                    anchor: new this.google.maps.Point(16, 16),
                    scaledSize: new this.google.maps.Size(30, 30),
                },
                halfTriggered: {
                    url: require("../../assets/marker/half_triggered.svg"),
                    size: new this.google.maps.Size(30, 30),
                    origin: new this.google.maps.Point(0, 0),
                    anchor: new this.google.maps.Point(16, 16),
                    scaledSize: new this.google.maps.Size(30, 30),
                },
            }
        },
    },
}
</script>

<style lang="scss">
.gmap {
    height: calc(100vh - 160px) !important;
    @media only screen and (max-width: 900px) {
        height: calc(100vh - 196px) !important;
    }
}
</style>
